export { AppComponent } from './app.component';
export { AppMenuComponent, AppSubMenuComponent ,AppMenuSettingComponent} from './app.menu.component';
export { AppSideBarComponent } from './app.sidebar.component';
export { AppSideBarTabContentComponent } from './app.sidebartabcontent.component';
export { AppTopBarComponent } from './app.topbar.component';
export { AppFooterComponent } from './app.footer.component';

import * as app from './';

import * as prime from 'primeng/primeng';
// import * as ngx from 'ngx-material-timepicker';
// import * as primes from 'primeng_BAK';

import * as mat from '@angular/material';
import * as matdat  from '@angular/material-moment-adapter'
export const AppComponents = [
     app.AppComponent,
     app.AppMenuComponent,
     app.AppSubMenuComponent,
     app.AppSideBarComponent,
     app.AppSideBarTabContentComponent,
     app.AppTopBarComponent,
     app.AppFooterComponent,
     app.AppMenuSettingComponent
];

export const PrimeNgModule = [
     prime.AccordionModule,
     prime.AutoCompleteModule,
     prime.BreadcrumbModule,
     prime.ButtonModule,
     prime.CalendarModule,
     prime.CarouselModule,
     prime.ColorPickerModule,
     prime.ChartModule,
     
     // prime.DataViewModule,
     // prime.CardModule,
     prime.CheckboxModule,
     prime.ChipsModule,
     prime.CodeHighlighterModule,
     prime.ConfirmDialogModule,
     prime.SharedModule,
     prime.ContextMenuModule,
     prime.DataGridModule,
     prime.DataListModule,
     prime.DataScrollerModule,
     prime.DataTableModule,
     prime.DialogModule,
     prime.DragDropModule,
     prime.DropdownModule,
     prime.EditorModule,
     prime.FieldsetModule,
     prime.FileUploadModule,
     prime.GalleriaModule,
     prime.GMapModule,
     prime.GrowlModule,
     prime.InputMaskModule,
     prime.InputSwitchModule,
     prime.InputTextModule,
     prime.InputTextareaModule,
     prime.LightboxModule,
     prime.ListboxModule,
     prime.MegaMenuModule,
     prime.MenuModule,
     prime.MenubarModule,
     prime.MessagesModule,
     prime.MultiSelectModule,
     prime.OrderListModule,
     prime.OrganizationChartModule,
     prime.OverlayPanelModule,
     prime.PaginatorModule,
     prime.PanelModule,
     prime.PanelMenuModule,
     prime.PasswordModule,
     prime.PickListModule,
     prime.ProgressBarModule,
     prime.RadioButtonModule,
     prime.RatingModule,
     prime.ScheduleModule,
     prime.SelectButtonModule,
     prime.SlideMenuModule,
     prime.SliderModule,
     prime.SpinnerModule,
     prime.SplitButtonModule,
     prime.StepsModule,
     prime.TabMenuModule,
     prime.TabViewModule,
     prime.TerminalModule,
     prime.TieredMenuModule,
     prime.ToggleButtonModule,
     prime.ToolbarModule,
     prime.TooltipModule,
     prime.TreeModule,
     prime.TreeTableModule,
     prime.InplaceModule,
     prime.DataScrollerModule,
     prime.ProgressSpinnerModule,
     // prime.TableModule,
];

export const materialModule = [
     mat.MatFormFieldModule,
     mat.MatAutocompleteModule,
     // mat.MatBadgeModule,
     // mat.MatBottomSheetModule,
     mat.MatButtonModule,
     mat.MatButtonToggleModule,
     mat.MatCardModule,
     mat.MatCheckboxModule,
     mat.MatChipsModule,
     mat.MatDatepickerModule,
     mat.MatDialogModule,
     // mat.MatDividerModule,
     mat.MatExpansionModule,
     mat.MatGridListModule,
     mat.MatIconModule,
     mat.MatInputModule,
     mat.MatListModule,
     mat.MatMenuModule,
     mat.MatNativeDateModule,
     mat.MatPaginatorModule,
     mat.MatProgressBarModule,
     mat.MatProgressSpinnerModule,
     mat.MatRadioModule,
     mat.MatRippleModule,
     mat.MatSelectModule,
     mat.MatSidenavModule,
     mat.MatSliderModule,
     mat.MatSlideToggleModule,
     mat.MatSnackBarModule,
     mat.MatSortModule,
     mat.MatStepperModule,
     mat.MatTableModule,
     mat.MatTabsModule,
     mat.MatToolbarModule,
     mat.MatTooltipModule,
     // mat.MatTreeModule,
     matdat.MatMomentDateModule,

];
// export const ngxModule = [
//      ngx.NgxMaterialTimepickerModule
// ]